export const getCurrencySymbol = (currencyCode: string): string => {
  const symbols: Record<string, string> = {
    USD: '$',
    SGD: '$',
    AUD: '$',
    CAD: '$',
    PHP: '₱',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
  };

  return symbols[currencyCode] ?? currencyCode;
};

export const formatCurrency = (
  amount: number,
  currencyCode = 'SGD'
): string =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount);

export const formatCurrencyCode = (
  amount: number,
  currencyCode = 'SGD'
): string => {
  const formattedAmount = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return `${currencyCode} ${formattedAmount}`;
};
